import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EditForm from '../components/EditForm';
import SingleRecordWorkspace from '../components/ui/SingleRecordWorkspace';
import NotificationSnackbar from '../components/ui/NotificationSnackbar';
import useLeadForm from '../hooks/useLeadForm';
import { DescriptionOutlined, SaveOutlined } from '@mui/icons-material';

const EditLead = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const initialLeadData = {
    first_name: '', last_name: '', email: '', phone_number: '', company_name: '', lead_status: 'new',
    contact_name: '', priority: 'medium', follow_up_date: '', assigned_salesperson: '', hotness: 1,
    amount: 0, notes: '', user: 'default_user', custom_fields: [],
  };

  const {
    leadData, customFields, activeTab, notification, handleChange, handleCustomFieldsUpdate,
    handleSubmit, handleCloseNotification, setActiveTab,
  } = useLeadForm(initialLeadData, true, id);

  const fullName = [leadData.first_name, leadData.last_name].filter(Boolean).join(' ').trim() || 'Contact';
  const submit = () => handleSubmit({ preventDefault: () => {} });
  const relatedGroups = [
    ['Quotations', leadData.quotations || [], '/quotations/', (item) => item.quotation_number || `Quotation #${item.id}`],
    ['Work orders', leadData.work_orders || [], '/workorders/', (item) => item.work_order_number || `Work Order #${item.id}`],
    ['Proforma invoices', leadData.proforma_invoices || [], '/proforma-invoices/', (item) => item.proforma_number || `Proforma #${item.id}`],
    ['Invoices', leadData.invoices || [], '/invoices/', (item) => item.invoice_number || `Invoice #${item.id}`],
  ];

  const cards = [
    {
      id: 'contact-actions', title: 'Actions', position: 'right', fixed: true, disableDrag: true,
      deletable: false, allowSettings: false, titleEditable: false, fieldKeys: [],
      customContent: () => <div className="record-action-buttons"><button type="button" className="hs-listing__create" title="Save changes" aria-label="Save changes" onClick={submit}><SaveOutlined /></button><button type="button" className="hs-listing__create" title="Create quotation" aria-label="Create quotation" onClick={() => navigate(`/quotation/create/${id}`)}><DescriptionOutlined /></button></div>,
    },
    {
      id: 'contact-related-documents', title: 'Related Documents', position: 'right', deletable: false, editable: false, fieldKeys: [],
      customContent: () => <div className="record-related-links">{relatedGroups.map(([label, items, path, getLabel]) => <div key={label}><strong>{label}</strong><span>{items.length}</span>{items.slice(0, 3).map((item) => <button type="button" key={item.id} onClick={() => navigate(`${path}${item.id}`)}>{getLabel(item)}</button>)}</div>)}</div>,
    },
  ];

  return <>
    <SingleRecordWorkspace
      storageKey={`jdh-crm:record:lead:${id}:edit`}
      backTo="/leads"
      backLabel="Contacts"
      title={fullName}
      subtitle={`${leadData.company_name || 'Contact'} · ${leadData.lead_status || 'new'}`}
      record={leadData}
      fields={[]}
      initialCards={cards}
      summaryCard={{ backTo: '/leads', backLabel: 'Contacts', displayTitle: fullName, subtitle: leadData.company_name || 'Contact', editable: false }}
      hidePageHeader
      centerLabel={null}
      centerContent={<EditForm leadData={leadData} handleChange={handleChange} handleSubmit={handleSubmit} customFields={customFields} handleCustomFieldsUpdate={handleCustomFieldsUpdate} activeTab={activeTab} setActiveTab={setActiveTab} hideActions />}
    />
    <NotificationSnackbar open={notification.open} message={notification.message} severity={notification.severity} onClose={handleCloseNotification} />
  </>;
};

export default EditLead;
